/* eslint-disable */
import styled, { css } from 'styled-components';
import cssKit from '../../css';

const nissan = process.env.BRAND_NAME === 'nissan';

export const PaginatorWrapperStyled = styled.div`
  position: relative;

  ${cssKit.media.greaterThan('small') `
  padding: 10px 50px 50px;
  `};
`;

export const PaginatorListStyled = styled.div`
  position: relative;
`;

export const PaginatorUiWrapperStyled = styled.div`
  position: relative;
  padding: 12px;
  user-select: none;
`;

export const PaginatorUiButtonWrapperStyled = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 25%;

  ${cssKit.media.greaterThan('small') `
    width: 15%;
  `};

  &:last-of-type {
    text-align: right;
  }
`;

export const PaginatorUiIndicatorsWrapperStyled = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 50%;

  ${cssKit.media.greaterThan('small') `
    width: 70%;
  `};
  text-align: center;
`;

export const PaginatorUiButtonStyled = styled.a`
  font-family: ${cssKit.fonts.bold};
  font-size: 10px;
  position: relative;
  margin-left: 20px;
  cursor: ${(props) => {
    return props.disabled ? 'default' : 'pointer';
  }};
  ${(props) =>
    props.next &&
    css`
      margin-left: 0;
      margin-right: 20px;
    `};
  &::before {
    position: absolute;
    top: 50%;
    left: -10px;
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-right: ${`1px solid ${nissan ? cssKit.vars.color_red_rgba(1) : '#000'}`};
    border-bottom: ${`1px solid ${nissan ? cssKit.vars.color_red_rgba(1) : '#000'}`};
    transform: translateY(-50%) rotate(130deg);
    transition: border-color 0.35s ease-out;

    ${(props) =>
    props.next &&
    css`
        transform: translateY(-50%) rotate(-45deg);
        left: auto;
        right: -10px;
      `};

    ${(props) =>
    props.disabled &&
    css`
        border-right: 1px solid ${cssKit.vars.color_black_rgba(0.3)};
        border-bottom: 1px solid ${cssKit.vars.color_black_rgba(0.3)};
      `};
  }
`;

export const PaginatorUiIndicatorStyled = styled.a`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 8px 4px;
  font-size: 10px;
  font-family: ${cssKit.fonts.bold};
  line-height: 2;
  background-color: ${cssKit.vars.color_white_rgba(1)};
  color: ${cssKit.vars.color_black_rgba(1)};
  cursor: pointer;
  transition: background-color 0.35s ease-out;

  ${(props) =>
    props.selected &&
    css`
      cursor: default;
      color: ${nissan ? cssKit.vars.color_white_rgba(1) : '#000'};
      border: ${nissan ? 'none': '1px solid #000'};
      background-color: ${nissan ? cssKit.vars.color_red_rgba(1) : '#fff'};
    `};

  ${cssKit.media.greaterThan('medium') `
    margin: 8px;
  `};
`;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/Paginator/styles.js
 **/